import { Paper, Typography } from '@material-ui/core'
import SignInBody from '../SignInBody/index.js'
import { useStyles } from './styles.js'
const SignIn = (props) => {
  const { setLoading } = props
  const classes = useStyles()
  return (
    <>
      <Paper className={classes.signin}>
        <div className={classes.signintext}>
          {' '}
          <Typography variant="subtitle2" classes={{ root: classes.root }}>
            Sign In
          </Typography>
        </div>
        <SignInBody setLoading={setLoading}></SignInBody>
      </Paper>
    </>
  )
}
export default SignIn
